import {RREmployeeType} from "./RREmployeeType";
import {RRTruckType} from "./RRTruckType";

export type RRFuelInvoiceLine = {
    total?: number | string | null;
    amount?: number | string | null;
    lineTotal?: number | string | null;
    sum?: number | string | null;
    value?: number | string | null;
    price?: number | string | null;
    unitPrice?: number | string | null;
    pricePerUnit?: number | string | null;
    netPrice?: number | string | null;
    grossPrice?: number | string | null;
    qty?: number | string | null;
    quantity?: number | string | null;
    units?: number | string | null;
    count?: number | string | null;
};

export type RRFuelInvoiceType = {
    id: string;
    driverId: string;
    truckId: string;
    driver?: RREmployeeType | null;
    truck?: RRTruckType | null;
    invNumber: string;
    invDate: Date;
    price: number;
    fuelAmount: number;
    startKm: number;
    endKm: number;
    avgPriceForKm: number;
    totalKm: number;
    notes?: string;
};

export type RRFuelInvoiceWithExtras = RRFuelInvoiceType & {
    driverLabel?: string | null;
    driverName?: string | null;
    truckLabel?: string | null;
    start_km?: number | null;
    end_km?: number | null;
    total_km?: number | null;
    number?: string | null;
    invoiceNumber?: string | null;
    inv_no?: string | null;
    total?: number | string | null;
    totalForInvoice?: number | string | null;
    totalAmount?: number | string | null;
    amount?: number | string | null;
    totalBrutto?: number | string | null;
    total_net?: number | string | null;
    invoiceTotal?: number | string | null;
    invTotal?: number | string | null;
    totals?: Record<string, number | string | null> | null;
    items?: RRFuelInvoiceLine[] | null;
    lines?: RRFuelInvoiceLine[] | null;
    rows?: RRFuelInvoiceLine[] | null;
    positions?: RRFuelInvoiceLine[] | null;
    entries?: RRFuelInvoiceLine[] | null;
    invoiceLines?: RRFuelInvoiceLine[] | null;
};

export type RRInvoiceListType = RRFuelInvoiceType[];

export const EMPTY_RR_INVOICE: RRFuelInvoiceType = {
    id: "",
    driverId: "",
    truckId: "",
    driver: null,
    truck: null,
    invNumber: "",
    invDate: new Date(),
    price: 0,
    fuelAmount: 0,
    startKm: 0,
    endKm: 0,
    avgPriceForKm: 0,
    totalKm: 0,
    notes: "",
};
